import type { FindMeetingsConfig } from '@/types/custom-playbooks';

/** Find meetings reads at most this many members' calendars (the server's
 * `play_find_meetings.MAX_CALENDARS`). */
export const FIND_MEETINGS_MAX_CALENDARS = 5;

/** Why a Find meetings step can't turn On yet, mirroring the server's
 * `play_find_meetings.validate_config`; null when it is complete. A calendar
 * that isn't connected still saves: On waits for Connect Google Calendar. */
export function findMeetingsConfigError(
  config: Partial<FindMeetingsConfig> | undefined
): string | null {
  const ids = config?.googleUserIds;
  if (
    !Array.isArray(ids) ||
    ids.length < 1 ||
    ids.length > FIND_MEETINGS_MAX_CALENDARS ||
    new Set(ids).size !== ids.length ||
    ids.some((id) => typeof id !== 'string' || !id || id.trim() !== id)
  )
    return 'Pick 1 to 5 calendars.';
  if (
    config?.matchBy !== undefined &&
    config.matchBy !== 'contact' &&
    config.matchBy !== 'company'
  )
    return 'Match by contact or company.';
  for (const days of [config?.lookbackDays, config?.lookaheadDays]) {
    if (
      days !== undefined &&
      (!Number.isInteger(days) || days < 1 || days > 365)
    )
      return 'Use 1 to 365 days.';
  }
  return null;
}
